import utils from '../../utils/tag-name';

const TAG_NAME = utils.constructTagName('tablist');

const ARROW_BUTTON_DIRECTION = {
  FORWARD: 'forward',
  BACKWARD: 'backward',
};

export { TAG_NAME, ARROW_BUTTON_DIRECTION };
